import { useEffect, useState } from "react";
import { loadTrackingScripts } from "../utils/tracking";
import { useTranslation } from "react-i18next";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consentData = localStorage.getItem("cookieConsent");

    if (!consentData) {
      setShowBanner(true);
      return;
    }

    const consent = JSON.parse(consentData);

    const sixMonths = 1000 * 60 * 60 * 24 * 30 * 6;

    if (Date.now() - consent.timestamp > sixMonths) {
      localStorage.removeItem("cookieConsent");
      setShowBanner(true);
      return;
    }

    if (consent.status === "accepted") {
      loadTrackingScripts();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({
        status: "accepted",
        timestamp: Date.now(),
      }),
    );

    loadTrackingScripts();
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({
        status: "rejected",
        timestamp: Date.now(),
      }),
    );

    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <div>
          <strong>🍪 {t("Cookie Notice")}</strong>

          <p>{t("Cookie Description")}</p>

          <a href="/privacy-policy" target="_blank" rel="noreferrer">
            {t("Read Privacy Policy")}
          </a>
        </div>

        <div className="cookie-buttons">
          <button className="cookie-accept" onClick={acceptCookies}>
            {t("Accept All")}
          </button>

          <button className="cookie-reject" onClick={rejectCookies}>
            {t("Reject")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
